import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ModalRoute } from "@src/appV2/redesign/Navigation/ModalRoute";
import { ModalTransitionSwitch } from "@src/appV2/redesign/Navigation/ModalTransitionSwitch";
import { ShiftBottomSheet } from "@src/appV2/redesign/Shift/BottomSheet/Sheet";
import { useLocation } from "react-router-dom";

import { BOOKING_REQUESTS_FULL_PATH } from "../path";

const BOOKING_REQUEST_SHIFT_MODAL_PATH = "shift/:shiftId";

export function BookingRequestsModalRoutes() {
  const location = useLocation();
  const goBackPath = `${BOOKING_REQUESTS_FULL_PATH}${location.search}`;

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <ModalTransitionSwitch>
        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={goBackPath}
          path={`${BOOKING_REQUESTS_FULL_PATH}/${BOOKING_REQUEST_SHIFT_MODAL_PATH}`}
          render={({ modalState }) => {
            return <ShiftBottomSheet modalState={modalState} />;
          }}
        />
      </ModalTransitionSwitch>
    </ThemeProvider>
  );
}
